<template>
    <div class="container">
        <h2>New User</h2>
        <div>
            <router-link to="/users" class="btn btn-link">
				<i class="fas fa-arrow-left"></i> Back to Users List
			</router-link>
        </div>
        <form @submit.prevent="submitForm" class="form-horizontal col-sm-6">
            <div class="form-group row">
                <label for="firstName" class="col-sm-4 col-form-label text-right">First Name *</label>
                <div class="col-sm-8">
                    <input type="text" class="form-control" id="firstName" required>
                </div>
            </div>
            <div class="form-group row">
                <label for="lastName" class="col-sm-4 col-form-label text-right">Last Name *</label>
                <div class="col-sm-8">
                    <input type="text" class="form-control" id="lastName" required>
                </div>
            </div>
            <div class="form-group row">
                <label for="email" class="col-sm-4 col-form-label text-right">Email *</label>
                <div class="col-sm-8">
                    <input type="email" class="form-control" id="email" required>
                </div>
            </div>
            <div class="form-group row">
                <label for="phone" class="col-sm-4 col-form-label text-right">Phone *</label>
                <div class="col-sm-8">
                    <input type="text" class="form-control" id="phone" required>
                </div>
            </div>
            <div class="form-group row">
                <label for="roles" class="col-sm-4 col-form-label text-right">Roles</label>
                <div class="col-sm-8">
                    <div v-for="role in allRoles" :key="role.id" class="form-check">
                        <input
                            type="checkbox"
                            class="form-check-input"
                            :id="role.id"
                            :value="role.id">
                        <label class="form-check-label" :for="role.id">{{ role.code }} ({{ role.description }})</label>
                    </div>
                </div>
            </div>
            <div class="form-group row">
                <label for="mfaRequired" class="col-sm-4 col-form-label text-right">MFA Required *</label>
                <div class="col-sm-8">
                    <select class="form-control" id="mfaRequired" required>
                        <option :value="true">Yes</option>
                        <option :value="false">No</option>
                    </select>
                </div>
            </div>
			<div class="form-group row">
				<div class="col-sm-8 offset-sm-4">
					<button type="submit" class="btn btn-primary">
                        <output v-if="loading" class="spinner-border spinner-border-sm" aria-hidden="true"></output>
                        Save
                    </button>
				</div>
			</div>
        </form>
    </div>   
</template>

<script>
import api from '@/api';
import eventBus from '@/utils/eventBus';
import { checkAuth } from '@/utils/auth';

export default {
    data() {
        return {
            allRoles: [],
            loading: false
        };
    },
    async mounted() {
        if (!(await checkAuth())) {
            eventBus.emit('show-alert', { message: 'You need to log in to access this page.', type: 'danger' });
            this.$router.push('/');
        } else {
            await this.fetchRoles();
        }
    },
    methods: {
        async fetchRoles() {
            try {
                const response = await api.get('/v1/roles', {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('accessToken')}`
                    },
                    params: { active: 'true' }
                });

                if (response.status === 200) {
                    this.allRoles = response.data.data.roles;
                } else {
                    eventBus.emit('show-alert', { message: response.data.message, type: 'danger' });
                }
            } catch (err) {
                console.error(err);
                if (err.response) {
                    console.error(err.response.data);
                }
            }
        },
        async submitForm() {
            this.loading = true;
            if (!(await checkAuth())) {
                eventBus.emit('show-alert', { message: 'You need to log in to access this page.', type: 'danger' });
                this.$router.push('/');
            } else {
                const firstName = document.getElementById('firstName').value;
                const lastName = document.getElementById('lastName').value;
                const email = document.getElementById('email').value;
                const phone = document.getElementById('phone').value;
                const mfaRequired = document.getElementById('mfaRequired').value;
                const roles = Array.from(document.querySelectorAll('input[type="checkbox"]:checked')).map(role => ({ id: role.value }));
                const redirectUrl = `${window.location.origin}/#/set-password`;

                try {
                    const response = await api.post('/v1/users', {
                        firstName,
                        lastName,
                        email,
                        phone,
                        roles,
                        mfaRequired,
                        active: 'true',
                        redirectUrl
                    }, {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem('accessToken')}`
                        }
                    });

                    if (response.status === 201) {
                        eventBus.emit('show-alert', { message: response.data.message, type: 'success' });
                        this.$router.push('/users');
                    } else {
                        eventBus.emit('show-alert', { message: response.data.message, type: 'danger' });
                    }
                } catch (err) {
                    console.error(err);
                    if (err.response) {
                        console.error(err.response.data);
                        eventBus.emit('show-alert', { message: err.response.data.message, type: 'danger' });
                    }
                }
            }
            this.loading = false;
        }
    }
};
</script>

<style>
.form-horizontal .form-group {
    margin-top: 1rem;
	margin-bottom: 1rem;
}
</style>